// The logged-in member's credits (GET /api/profile/credit-summary), shared
// by the dashboard card and the sidebar so the page makes one request.
// `refreshKey` (for example the profile object) reloads it when it changes.
import { useEffect, useState } from "react";
import { profileAPI } from "../services/api";

let inFlight = null;

const loadSummary = () => {
  if (!inFlight) {
    inFlight = profileAPI
      .getCreditSummary()
      .then((response) => response.data)
      .finally(() => {
        // Keep the shared request only while it runs.
        setTimeout(() => {
          inFlight = null;
        }, 0);
      });
  }
  return inFlight;
};

export function useMemberCreditSummary(refreshKey) {
  const [state, setState] = useState({ summary: null, loading: true, error: null });

  useEffect(() => {
    let active = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    loadSummary()
      .then((summary) => {
        if (active) setState({ summary, loading: false, error: null });
      })
      .catch(() => {
        if (active) setState({ summary: null, loading: false, error: "Could not load your credits." });
      });
    return () => {
      active = false;
    };
  }, [refreshKey]);

  return state;
}

// For tests.
export const resetMemberCreditSummaryCache = () => {
  inFlight = null;
};
